import React from 'react'

const ZariDropdownDivider = () => {
  return (
    <li
      style={{
        width: '100%',
        padding: '2px 10px'
      }}
    >
      <div
        style={{
          width: '100%',
          backgroundColor: '#5e5e5e',
          height: '1px'
        }}
      ></div>
    </li>
  )
}

export default ZariDropdownDivider
